module.exports = __webpack_public_path__ + "010affa2543fb857238efff6d0fc16c6.jpg";